var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _c("header-tabs", { attrs: { active: _vm.$route.path } }),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "filter" },
        [
          _c("el-col", [
            _c(
              "div",
              {
                staticStyle: {
                  background: "#f3f3f3",
                  height: "30px",
                  "line-height": "30px",
                  padding: "0 25px",
                  display: "flex",
                  "align-items": "center"
                }
              },
              [_c("div", [_vm._v("分播机配置（配置仅对中分位分播生效）")])]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { padding: "20px 25px 0" } },
              [
                _c(
                  "el-form",
                  { attrs: { inline: true, model: _vm.cutSettingForm } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "中分位分播并自动汇集" } },
                      [
                        _c("el-switch", {
                          model: {
                            value: _vm.cutSettingForm.auto_collect,
                            callback: function($$v) {
                              _vm.$set(_vm.cutSettingForm, "auto_collect", $$v)
                            },
                            expression: "cutSettingForm.auto_collect"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "格口单次落入件数" } },
                      [
                        _c("el-input-number", {
                          attrs: { min: 1, max: 1000 },
                          model: {
                            value: _vm.cutSettingForm.grid_piece_num,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.cutSettingForm,
                                "grid_piece_num",
                                $$v
                              )
                            },
                            expression: "cutSettingForm.grid_piece_num"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "中分位分播时单件波次是否进入指定格口号"
                            }
                          },
                          [
                            _c("el-switch", {
                              on: { change: _vm.handleChangeOpen },
                              model: {
                                value: _vm.cutSettingForm.single_grid,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.cutSettingForm,
                                    "single_grid",
                                    $$v
                                  )
                                },
                                expression: "cutSettingForm.single_grid"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          [
                            _c("el-input", {
                              attrs: {
                                disabled: _vm.cutSettingForm.single_grid,
                                placeholder: "格口号",
                                clearable: ""
                              },
                              model: {
                                value: _vm.cutSettingForm.grid_no,
                                callback: function($$v) {
                                  _vm.$set(_vm.cutSettingForm, "grid_no", $$v)
                                },
                                expression: "cutSettingForm.grid_no"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "中分位分播时部分板位粗分" } },
                          [
                            _c("el-switch", {
                              model: {
                                value: _vm.cutSettingForm.open_rough,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.cutSettingForm,
                                    "open_rough",
                                    $$v
                                  )
                                },
                                expression: "cutSettingForm.open_rough"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                "\n                （功能开启后以下中分位分组将进行粗分并进入指定格口）\n              "
                              )
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.cutSettingForm.rough_grid, function(
                          tag,
                          index
                        ) {
                          return _c(
                            "el-tag",
                            {
                              key: "tag-" + tag.grid_no + "-" + index,
                              staticStyle: {
                                margin: "10px 10px 0 0",
                                "white-space": "normal",
                                "word-wrap": "break-word",
                                height: "auto"
                              },
                              attrs: {
                                "disable-transitions": false,
                                closable: ""
                              },
                              on: {
                                close: function($event) {
                                  return _vm.handleRoughGridTagClose(index)
                                },
                                click: function($event) {
                                  return _vm.showRoughGridModal(tag)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n              格口号：" +
                                  _vm._s(tag.grid_no) +
                                  "； 中分位：" +
                                  _vm._s(tag.hg_group) +
                                  "\n            "
                              )
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _c("el-button", {
                          attrs: {
                            type: "primary",
                            plain: "",
                            icon: "el-icon-plus"
                          },
                          on: {
                            click: function($event) {
                              return _vm.showRoughGridModal()
                            }
                          }
                        })
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "异常格口配置" } },
                          [
                            _c("el-switch", {
                              model: {
                                value: _vm.cutSettingForm.open_exception,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.cutSettingForm,
                                    "open_exception",
                                    $$v
                                  )
                                },
                                expression: "cutSettingForm.open_exception"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(" （开启后对应异常原因进入指定格口） ")
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.cutSettingForm.exception_grid, function(
                          tag,
                          index
                        ) {
                          return _c(
                            "el-tag",
                            {
                              key: "tag-" + tag.grid_no + "-" + index,
                              staticStyle: {
                                margin: "10px 10px 0 0",
                                "white-space": "normal",
                                "word-wrap": "break-word",
                                height: "auto"
                              },
                              attrs: {
                                "disable-transitions": false,
                                closable: ""
                              },
                              on: {
                                close: function($event) {
                                  return _vm.handleExceptionGridTagClose(
                                    index,
                                    "cutSettingForm"
                                  )
                                },
                                click: function($event) {
                                  return _vm.showExceptionGridModal(
                                    "fenbo",
                                    tag
                                  )
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n              格口号：" +
                                  _vm._s(tag.grid_no) +
                                  "； 异常原因：" +
                                  _vm._s(tag.ex_text) +
                                  "\n            "
                              )
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _c("el-button", {
                          attrs: {
                            type: "primary",
                            plain: "",
                            icon: "el-icon-plus"
                          },
                          on: {
                            click: function($event) {
                              return _vm.showExceptionGridModal("fenbo")
                            }
                          }
                        })
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "primary",
                                  loading: _vm.cutSettingLoading
                                },
                                on: { click: _vm.saveCutSettingData }
                              },
                              [_vm._v("\n                保存\n              ")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "filter" },
        [
          _c("el-col", [
            _c(
              "div",
              {
                staticStyle: {
                  background: "#f3f3f3",
                  height: "30px",
                  "line-height": "30px",
                  padding: "0 25px",
                  display: "flex",
                  "align-items": "center"
                }
              },
              [_c("div", [_vm._v("波次分播配置（配置仅对波次分播生效））")])]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { padding: "20px 25px 0" } },
              [
                _c(
                  "el-form",
                  { attrs: { inline: true } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "按波次分播区分中分板位配置：" } },
                          [
                            _c("el-switch", {
                              attrs: {
                                "active-value": _vm.constantMap.OPEN,
                                "inactive-value": _vm.constantMap.CLOSE
                              },
                              on: { change: _vm.handleIsOpenChange },
                              model: {
                                value: _vm.is_open,
                                callback: function($$v) {
                                  _vm.is_open = $$v
                                },
                                expression: "is_open"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-form-item",
                          [
                            _c("el-cascader", {
                              attrs: {
                                options: _vm.halveOptions,
                                props: { multiple: true },
                                placeholder: "选择中分位",
                                "collapse-tags": "",
                                clearable: "",
                                "show-all-levels": false
                              },
                              model: {
                                value: _vm.halveIds,
                                callback: function($$v) {
                                  _vm.halveIds = $$v
                                },
                                expression: "halveIds"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            "\n              波次分播时只对配置中的波次进行分播，不在配置中的波次将进入以下格口\n            "
                          )
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.appointedGrid, function(tag, index) {
                          return _c(
                            "el-tag",
                            {
                              key: "tag-" + tag.grid_no + "-" + index,
                              staticStyle: {
                                margin: "10px 10px 0 0",
                                "white-space": "normal",
                                "word-wrap": "break-word",
                                height: "auto"
                              },
                              attrs: {
                                closable: "",
                                "disable-transitions": false
                              },
                              on: {
                                close: function($event) {
                                  return _vm.handleAppointedGridTagClose(index)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n              格口号：" +
                                  _vm._s(tag.grid_no) +
                                  "； 中分位：\n              "
                              ),
                              _vm._l(tag.hg_ids, function(hgid, i) {
                                return _c(
                                  "span",
                                  { key: "hgid-" + hgid.label + "-" + i },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(hgid.label) +
                                        ",\n              "
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          )
                        }),
                        _vm._v(" "),
                        _c("el-button", {
                          attrs: {
                            type: "primary",
                            plain: "",
                            icon: "el-icon-plus"
                          },
                          on: {
                            click: function($event) {
                              _vm.isAppointedGridModalVisible = true
                            }
                          }
                        })
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "异常格口配置" } },
                          [
                            _c("el-switch", {
                              model: {
                                value:
                                  _vm.waveDistributionConfig.open_exception,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.waveDistributionConfig,
                                    "open_exception",
                                    $$v
                                  )
                                },
                                expression:
                                  "waveDistributionConfig.open_exception"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(" （开启后对应异常原因进入指定格口） ")
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm._l(
                          _vm.waveDistributionConfig.exception_grid,
                          function(tag, index) {
                            return _c(
                              "el-tag",
                              {
                                key: "tag-" + tag.grid_no + "-" + index,
                                staticStyle: {
                                  margin: "10px 10px 0 0",
                                  "white-space": "normal",
                                  "word-wrap": "break-word",
                                  height: "auto"
                                },
                                attrs: {
                                  "disable-transitions": false,
                                  closable: ""
                                },
                                on: {
                                  close: function($event) {
                                    return _vm.handleExceptionGridTagClose(
                                      index,
                                      "waveDistributionConfig"
                                    )
                                  },
                                  click: function($event) {
                                    return _vm.showExceptionGridModal(
                                      "wave",
                                      tag
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n              格口号：" +
                                    _vm._s(tag.grid_no) +
                                    "； 异常原因：" +
                                    _vm._s(tag.ex_text) +
                                    "\n            "
                                )
                              ]
                            )
                          }
                        ),
                        _vm._v(" "),
                        _c("el-button", {
                          attrs: {
                            type: "primary",
                            plain: "",
                            icon: "el-icon-plus"
                          },
                          on: {
                            click: function($event) {
                              return _vm.showExceptionGridModal("wave")
                            }
                          }
                        })
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "" } },
                          [
                            _c("el-switch", {
                              attrs: {
                                "active-value": _vm.constantMap.OPEN_WAVE_GRID,
                                "inactive-value":
                                  _vm.constantMap.CLOSE_WAVE_GRID
                              },
                              model: {
                                value: _vm.open_wave_grid,
                                callback: function($$v) {
                                  _vm.open_wave_grid = $$v
                                },
                                expression: "open_wave_grid"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticStyle: { "margin-right": "10px" } },
                              [_vm._v(" 当波次待发货数量≥")]
                            ),
                            _vm._v(" "),
                            _c("YsInput", {
                              staticStyle: { width: "100px" },
                              attrs: { pattern: "positiveInt" },
                              model: {
                                value: _vm.open_wave_num,
                                callback: function($$v) {
                                  _vm.open_wave_num = $$v
                                },
                                expression: "open_wave_num"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticStyle: { "margin-left": "10px" } },
                              [_vm._v("则优先进入双数号格口")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "primary",
                                  loading: _vm.cutSettingLoading
                                },
                                on: { click: _vm.handleHalveDataSave }
                              },
                              [_vm._v("\n                保存\n              ")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "filter" },
        [
          _c(
            "el-col",
            [
              _c(
                "div",
                {
                  staticStyle: {
                    background: "#f3f3f3",
                    height: "30px",
                    "line-height": "30px",
                    padding: "0 25px",
                    display: "flex",
                    "align-items": "center"
                  }
                },
                [
                  _c("div", [_vm._v("筛选查询")]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "auto" },
                      attrs: {
                        type: "text",
                        icon: _vm.filterFold
                          ? "el-icon-arrow-down"
                          : "el-icon-arrow-up"
                      },
                      on: { click: _vm.toggleFilter }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.filterFold ? "展开筛选" : "收起筛选") +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-collapse-transition", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.filterFold,
                        expression: "!filterFold"
                      }
                    ]
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { padding: "10px 25px" } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-form",
                              {
                                staticClass: "demo-form-inline",
                                attrs: { inline: true, model: _vm.form }
                              },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "输入搜索：" } },
                                  [
                                    _c("el-input", {
                                      attrs: { placeholder: "格口" },
                                      nativeOn: {
                                        keyup: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          return _vm.search.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.form.grid_no,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "grid_no", $$v)
                                        },
                                        expression: "form.grid_no"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: { placeholder: "是否开启" },
                                        model: {
                                          value: _vm.form.is_use,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "is_use", $$v)
                                          },
                                          expression: "form.is_use"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { label: "全部", value: "" }
                                        }),
                                        _vm._v(" "),
                                        _vm._l(_vm.is_use, function(item) {
                                          return _c("el-option", {
                                            key: item.key,
                                            attrs: {
                                              label: item.name,
                                              value: item.key
                                            }
                                          })
                                        })
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: { placeholder: "是否一键打包" },
                                        model: {
                                          value: _vm.form.is_check_one_out,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "is_check_one_out",
                                              $$v
                                            )
                                          },
                                          expression: "form.is_check_one_out"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { label: "全部", value: "" }
                                        }),
                                        _vm._v(" "),
                                        _vm._l(_vm.is_check_one_out, function(
                                          item
                                        ) {
                                          return _c("el-option", {
                                            key: item.key,
                                            attrs: {
                                              label: item.name,
                                              value: item.key
                                            }
                                          })
                                        })
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: { placeholder: "波次拣货属性" },
                                        model: {
                                          value: _vm.form.picking_type,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "picking_type",
                                              $$v
                                            )
                                          },
                                          expression: "form.picking_type"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: {
                                            label: "显示全部",
                                            value: ""
                                          }
                                        }),
                                        _vm._v(" "),
                                        _vm._l(_vm.picking_type, function(
                                          item
                                        ) {
                                          return _c("el-option", {
                                            key: item.key,
                                            attrs: {
                                              label: item.name,
                                              value: item.key
                                            }
                                          })
                                        })
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "success" },
                                        on: { click: _vm.search }
                                      },
                                      [_vm._v("查询")]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      !_vm.loading
        ? _c(
            "el-row",
            [
              _c("el-col", { staticStyle: { border: "1px solid #ddd" } }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      background: "#f3f3f3",
                      height: "50px",
                      "line-height": "30px",
                      padding: "0 25px",
                      display: "flex",
                      "align-items": "center"
                    }
                  },
                  [
                    _c("div", [_vm._v("数据列表：")]),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticStyle: { "margin-left": "auto" },
                        attrs: { type: "primary", size: "mini" },
                        on: {
                          click: function($event) {
                            return _vm.batch_dialog()
                          }
                        }
                      },
                      [_vm._v("批量编辑\n        ")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.resData
                  ? _c(
                      "div",
                      { staticStyle: { "margin-bottom": "0" } },
                      [
                        _c(
                          "el-table",
                          {
                            directives: [
                              {
                                name: "loading",
                                rawName: "v-loading",
                                value: _vm.tableLoading,
                                expression: "tableLoading"
                              }
                            ],
                            ref: "multipleTable",
                            staticStyle: { width: "100%" },
                            attrs: {
                              height: "600",
                              data: _vm.resData.data,
                              "tooltip-effect": "dark"
                            },
                            on: {
                              "selection-change": _vm.handleSelectionChange
                            }
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                align: "right",
                                type: "selection",
                                width: "55"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: { prop: "grid_no", label: "格口" }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "is_use_txt",
                                label: "是否开启",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "grid_picking_type",
                                label: "波次拣货属性",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "grid_is_check_one_out",
                                label: "是否一键打包",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: "操作",
                                "show-overflow-tooltip": "",
                                align: "center"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "text",
                                              size: "small"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.edit_grid(scope.row)
                                              }
                                            }
                                          },
                                          [_vm._v("操作\n              ")]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                3143081957
                              )
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.resData
                  ? _c(
                      "div",
                      {
                        staticStyle: { "text-align": "right", padding: "25px" }
                      },
                      [
                        _c("el-pagination", {
                          attrs: {
                            "current-page": _vm.resData.current_page,
                            background: "",
                            layout: "total, prev, pager, next, jumper ,sizes",
                            total: _vm.resData.total,
                            "page-size": _vm.form.pagesize,
                            "page-sizes": [20, 50, 100]
                          },
                          on: {
                            "update:currentPage": function($event) {
                              return _vm.$set(
                                _vm.resData,
                                "current_page",
                                $event
                              )
                            },
                            "update:current-page": function($event) {
                              return _vm.$set(
                                _vm.resData,
                                "current_page",
                                $event
                              )
                            },
                            "current-change": _vm.handleCurrentChange,
                            "size-change": _vm.handleSizeChange
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "格口编辑",
            visible: _vm.dialogFormVisible,
            width: "20%"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogFormVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.form } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "格口是否开启:" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "格口是否开启" },
                      model: {
                        value: _vm.form.edit_is_use,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "edit_is_use", $$v)
                        },
                        expression: "form.edit_is_use"
                      }
                    },
                    _vm._l(_vm.is_use, function(item) {
                      return _c("el-option", {
                        key: item.key,
                        attrs: { label: item.name, value: item.key }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "波次拣货属性:" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "波次拣货属性" },
                      model: {
                        value: _vm.form.edit_picking_type,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "edit_picking_type", $$v)
                        },
                        expression: "form.edit_picking_type"
                      }
                    },
                    _vm._l(_vm.picking_type, function(item) {
                      return _c("el-option", {
                        key: item.key,
                        attrs: { label: item.name, value: item.key }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "一键打包:" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "一键打包" },
                      model: {
                        value: _vm.form.edit_is_check_one_out,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "edit_is_check_one_out", $$v)
                        },
                        expression: "form.edit_is_check_one_out"
                      }
                    },
                    _vm._l(_vm.is_check_one_out, function(item) {
                      return _c("el-option", {
                        key: item.key,
                        attrs: { label: item.name, value: item.key }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.dialogFormVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.edit_commit()
                    }
                  }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.isShowComfirmModal,
            title: "提示",
            width: "30%",
            "before-close": _vm.handleSingleGridCancel
          },
          on: {
            "update:visible": function($event) {
              _vm.isShowComfirmModal = $event
            }
          }
        },
        [
          _c("span", [
            _vm._v(
              "是否" +
                _vm._s(_vm.cutSettingForm.single_grid ? "打开" : "关闭") +
                "中分位分播时单件波次是否进入指定格口号功能？"
            )
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.handleSingleGridCancel } }, [
                _vm._v("取 消")
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.handleSingleGridConfirm(
                        _vm.cutSettingForm.single_grid
                      )
                    }
                  }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.isOpenModalVisible,
            title: "提示",
            width: "30%",
            "before-close": _vm.handleOpenModalCancel
          },
          on: {
            "update:visible": function($event) {
              _vm.isOpenModalVisible = $event
            }
          }
        },
        [
          _c("span", [
            _vm._v(
              "是否" +
                _vm._s(_vm.is_open === _vm.constantMap.OPEN ? "开启" : "关闭") +
                "按波次分播区分中分板位配置？"
            )
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.handleOpenModalCancel } }, [
                _vm._v("取 消")
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.handleOpenModalConfirm(_vm.is_open)
                    }
                  }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.isAppointedGridModalVisible,
            width: "80%",
            "before-close": _vm.handleAppointedGridModalCancel
          },
          on: {
            "update:visible": function($event) {
              _vm.isAppointedGridModalVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "halveModalForm",
              attrs: {
                model: _vm.halveModalForm,
                rules: _vm.halveModalFormRules
              }
            },
            [
              _c(
                "el-form-item",
                {
                  staticStyle: { display: "flex", width: "300px" },
                  attrs: {
                    prop: "grid_no",
                    label: "格口号：",
                    rules: {
                      required: true,
                      message: "格口号必填",
                      trigger: "blur"
                    }
                  }
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入内容" },
                    model: {
                      value: _vm.halveModalForm.grid_no,
                      callback: function($$v) {
                        _vm.$set(_vm.halveModalForm, "grid_no", $$v)
                      },
                      expression: "halveModalForm.grid_no"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "中分位分组：",
                    prop: "hg_ids",
                    rules: {
                      type: "array",
                      required: true,
                      message: "中分位分组必选",
                      trigger: "change"
                    }
                  }
                },
                [
                  _c(
                    "div",
                    [
                      _c(
                        "el-checkbox",
                        {
                          on: { change: _vm.selectAllHalveGroups },
                          model: {
                            value: _vm.selectAllChecked,
                            callback: function($$v) {
                              _vm.selectAllChecked = $$v
                            },
                            expression: "selectAllChecked"
                          }
                        },
                        [_vm._v("全选\n          ")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    _vm._l(_vm.selectedHgIds, function(item, index) {
                      return _c("span", { key: index }, [_vm._v(_vm._s(item))])
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c(
                    "el-checkbox-group",
                    {
                      model: {
                        value: _vm.halveModalForm.hg_ids,
                        callback: function($$v) {
                          _vm.$set(_vm.halveModalForm, "hg_ids", $$v)
                        },
                        expression: "halveModalForm.hg_ids"
                      }
                    },
                    _vm._l(_vm.halveGroupIdOptions, function(item) {
                      return _c(
                        "el-checkbox",
                        { key: item.value, attrs: { label: item, border: "" } },
                        [_vm._v(_vm._s(item.label) + "\n          ")]
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                { on: { click: _vm.handleAppointedGridModalCancel } },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleAppointedGridModalConfirm }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "粗分配置",
            visible: _vm.isRoughGridModalVisible,
            width: "50%"
          },
          on: {
            "update:visible": function($event) {
              _vm.isRoughGridModalVisible = $event
            },
            close: _vm.handleRoughGridModalCancel
          }
        },
        [
          _c(
            "el-form",
            { ref: "roughModalForm", attrs: { model: _vm.roughModalForm } },
            [
              _c(
                "el-form-item",
                {
                  staticStyle: { display: "flex", width: "300px" },
                  attrs: {
                    prop: "grid_no",
                    label: "格口号：",
                    rules: {
                      required: true,
                      message: "格口号必填",
                      trigger: "blur"
                    }
                  }
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入内容" },
                    model: {
                      value: _vm.roughModalForm.grid_no,
                      callback: function($$v) {
                        _vm.$set(_vm.roughModalForm, "grid_no", $$v)
                      },
                      expression: "roughModalForm.grid_no"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "中分位编码：",
                    prop: "hg_ids",
                    rules: {
                      type: "array",
                      required: true,
                      message: "中分位粗分必选",
                      trigger: "change"
                    }
                  }
                },
                [
                  _c("el-cascader", {
                    attrs: {
                      options: _vm.halveOptions,
                      props: { multiple: true },
                      placeholder: "选择中分位",
                      clearable: "",
                      "show-all-levels": false
                    },
                    model: {
                      value: _vm.roughModalForm.hg_ids,
                      callback: function($$v) {
                        _vm.$set(_vm.roughModalForm, "hg_ids", $$v)
                      },
                      expression: "roughModalForm.hg_ids"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                { on: { click: _vm.handleRoughGridModalCancel } },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleRoughGridModalConfirm }
                },
                [_vm._v("\n        确 定\n      ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "异常格口配置",
            visible: _vm.isExceptionGridModalVisible,
            width: "50%"
          },
          on: {
            "update:visible": function($event) {
              _vm.isExceptionGridModalVisible = $event
            },
            close: _vm.handleExceptionGridModalCancel
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "exceptionModalForm",
              attrs: { model: _vm.exceptionModalForm }
            },
            [
              _c(
                "el-form-item",
                {
                  staticStyle: { display: "flex", width: "300px" },
                  attrs: {
                    prop: "grid_no",
                    label: "格口号：",
                    rules: {
                      required: true,
                      message: "格口号必填",
                      trigger: "blur"
                    }
                  }
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入内容" },
                    model: {
                      value: _vm.exceptionModalForm.grid_no,
                      callback: function($$v) {
                        _vm.$set(_vm.exceptionModalForm, "grid_no", $$v)
                      },
                      expression: "exceptionModalForm.grid_no"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "异常原因：",
                    prop: "ex_ids",
                    rules: {
                      type: "array",
                      required: true,
                      message: "异常原因必选",
                      trigger: "change"
                    }
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        multiple: "",
                        placeholder: "选择原因",
                        clearable: ""
                      },
                      model: {
                        value: _vm.exceptionModalForm.ex_ids,
                        callback: function($$v) {
                          _vm.$set(_vm.exceptionModalForm, "ex_ids", $$v)
                        },
                        expression: "exceptionModalForm.ex_ids"
                      }
                    },
                    _vm._l(_vm.exceptionOptions, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                { on: { click: _vm.handleExceptionGridModalCancel } },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleExceptionGridModalConfirm }
                },
                [_vm._v("\n        确 定\n      ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2e31b52f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e31b52f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/wavepicking/GridSetting.vue
// module id = null
// module chunks = 